import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Spinner, InlineUploaderLayout } from '../ui';

const { DropzoneWrapper, DropzoneTextWrapper, DropzoneText, HighlightedText, CompactSpinner } = InlineUploaderLayout;

const DropzoneArea = ({
  onDrop,
  onDropRejected,
  allowedFileTypes,
  constraintText,
  isLoading,
  maxNumberOfFilesMessage,
  disabled,
  hasError
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDrop,
    onDropRejected: onDropRejected,
    multiple: maxNumberOfFilesMessage > 1,
    maxFiles: maxNumberOfFilesMessage,
    accept: allowedFileTypes?.accept,
    disabled: isLoading || disabled
  });

  return (
    <DropzoneWrapper
      {...getRootProps()}
      $isDragActive={isDragActive}
      $isDisabled={isLoading || disabled}
      $hasError={hasError}
    >
      {isLoading ? (
        <DropzoneTextWrapper>
          <CompactSpinner>
            <Spinner />
          </CompactSpinner>
        </DropzoneTextWrapper>
      ) : (
        <>
          <input {...getInputProps()} />
          <DropzoneTextWrapper>
            {hasError && <DropzoneText style={{ color: 'var(--primary-oqio-red)' }}>Datei fehlt.</DropzoneText>}
            <DropzoneText>
              {constraintText ? `${constraintText} auf diese Fläche ziehen oder` : 'Datei auf diese Fläche ziehen oder'}{' '}
              <HighlightedText>Datei auswählen</HighlightedText>
            </DropzoneText>
          </DropzoneTextWrapper>
        </>
      )}
    </DropzoneWrapper>
  );
};

export default DropzoneArea;
